/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
function renderRadioBtn(block, id, option, content) {
	const btn = document.createElement('button');

	btn.classList.add('tk-blk-radio-option');

	btn.addEventListener('click', (e) => {
		if (
			e.target === radio ||
			e.target === label
		) {
			return;
		}

		radio.checked = true;

		radio.dispatchEvent(
			new Event('change', { bubbles: true })
		);
	});

	const radio = document.createElement('input');
	radio.classList.add('tk-blk-input-radio');
	radio.type = 'radio';
	radio.name = `choice-${id}`;
	radio.id = `choice-${id}-${option}`;
	radio.value = option;

	radio.addEventListener('change', () => {
		const allOptions = block.querySelectorAll('.tk-blk-radio-option');

		allOptions.forEach(option => {
			option.classList.remove('tk-blk-radio-option-selected');
		});

		btn.classList.add('tk-blk-radio-option-selected');
	});

	const label = document.createElement('label');
	label.htmlFor = `choice-${id}-${option}`;
	label.classList.add('tk-blk-input-radio-label');
	label.innerHTML = `${option}. ${content}`;

	btn.appendChild(radio);
	btn.appendChild(label);

	return btn;
}

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.tk-blk-question-choice');

	blocks.forEach(block => {
		const imageUrl = block.dataset.image;
		// Obtiene los datos en bruto ingresados desde el editor
		const raw = block.dataset.raw;

		// Separa los datos obtenidos en líneas individuales
		const lines = raw.split('\n')
			.filter(line => line.trim() !== '');

		block.innerHTML = '';

		const questionID = `${
			Date.now().toString(36)
		}${
			Math.random().toString(36).slice(2)
		}`;
		
		const correctAnswers = [];

		let counter = 10;

		const number = document.createElement('span');
		number.classList.add('tk-blk-question-number');

		if (imageUrl) {
			const img = document.createElement('img');
			
			img.src = imageUrl;
			img.classList.add('tk-blk-choice-image');
			
			const imgDiv = document.createElement('div');

			imgDiv.classList.add('tk-blk-choice-img-container')
			imgDiv.appendChild(img);
			
			block.appendChild(number);
			block.appendChild(imgDiv);
		}

		lines.forEach((line, index) => {
			// Ignora líneas vacías
			if (!line.trim()) return;

			if (line.startsWith('-') || line.startsWith('+')) {
				// Crear la letra de cada alternativa
				const actualValue = (counter++).toString(36);
				// Agregando como correctas las alternativas que empiezan con +
				if (line.startsWith('+')) {
					correctAnswers.push(actualValue);
				}
				
				block.appendChild(
					renderRadioBtn(
						block,
						questionID,
						actualValue,
						line.slice(1).trim()
					)
				);
			} else {
				const p = document.createElement('p');
				p.classList.add('tk-blk-choice-p');
				if (!number.isConnected && index == 0) {
					p.appendChild(number);
				}
				p.appendChild(document.createTextNode(line.trim()));

				block.appendChild(p);
			}
		});

		if (!number.isConnected) {
			block.prepend(number);
		}

		block.dataset.correctAnswers = JSON.stringify(correctAnswers);

		block.evaluateBlock = () => {
			const selected = block.querySelector('input[type="radio"]:checked');

			// Si no hay alternativa seleccionada
			if (!selected) {
				return { correct: 0, total: 1 };
			}

			const correctAnswers = JSON.parse(block.dataset.correctAnswers);
			const options = block.querySelectorAll('.tk-blk-radio-option');
			const selectedContainer = selected.closest('.tk-blk-radio-option');
			const isCorrect = correctAnswers.includes(selected.value);
			
			options.forEach(option => {
				option.classList.remove(
					'tk-blk-radio-option-ok',
					'tk-blk-radio-option-wrong'
				);
			});

			if (isCorrect) {
				selectedContainer.classList.add(
					'tk-blk-radio-option-ok'
				);
			} else {
				selectedContainer.classList.add(
					'tk-blk-radio-option-wrong'
				);
			}

			return {
				correct: isCorrect ? 1 : 0,
				total: 1
			};
		};
	});
});
/* eslint-enable no-console */
